// import {
//   StrictMode,
// } from 'react'

import {
  createRoot,
} from 'react-dom/client'

import {
  QueryClientProvider,
} from '@tanstack/react-query'

import {
  RouterProvider,
} from '@tanstack/react-router'

import {
  initializeI18n,
} from '@/app/i18n/i18n'

import {
  ThemeProvider,
} from '@/app/providers/theme-provider'

import {
  router,
} from '@/app/router/router'

import {
  queryClient,
} from '@/shared/query/query-client'

import '@/app/styles/index.css'
import { AppToaster } from './shared/components/ui'

async function bootstrap():
  Promise<void> {
  /*
   * Translations must be initialized before
   * components start calling useTranslation().
   */
  await initializeI18n()

  const rootElement =
    document.getElementById('root')

  if (!rootElement) {
    throw new Error(
      "The root HTML element with id 'root' was not found.",
    )
  }

  createRoot(rootElement).render(
      <QueryClientProvider
        client={queryClient}
      >
        <ThemeProvider>
          <RouterProvider
            router={router}
          />
        </ThemeProvider>

        <AppToaster />

        {/* {import.meta.env.DEV ? (
          <ReactQueryDevtools
            initialIsOpen={false}
          />
        ) : null} */}
      </QueryClientProvider>
  )
}

void bootstrap()